import type {IAccountAddresses, ICpAddress} from '~/types';
import {accountPaths} from '~/utils/services/paths';
import {useCpUser} from '~/composables/useCpUser';

export type AddressDefaultUpdate = {
    /** If true, address will become the activeAddress */
    autoSelect?: boolean;
}

export type AddressUpdate =
    | (Omit<ICpAddress, 'id' | 'verified'> & AddressDefaultUpdate)
    // When we just want to update the default address.
    | AddressDefaultUpdate

export interface IEditAddress {
    addressId: string
    address: AddressUpdate
}

export const getAddresses = async (userEmail: string) => {
    return await $cpFetch<IAccountAddresses>(accountPaths.addresses(userEmail));
};

export const addAddress = async (userEmail: string, address: AddressUpdate) => {
    return await $cpFetch<IAccountAddresses|null>(accountPaths.addresses(userEmail), {
        method: 'POST',
        body: {...address, autoSelect: true},
    });
};

export const editAddress = async (
    userEmail: string,
    editAddress: IEditAddress,
    justSetAsDefault = false,
    ) => {
        const body = justSetAsDefault ? {autoSelect: true} : {...editAddress.address, autoSelect: true};
        return await $cpFetch<IAccountAddresses|null>(
            accountPaths.addressesSingle(userEmail, editAddress.addressId), {
            method: 'PUT',
            body,
        });
    };

export const deleteAddress = async (
    userEmail: string,
    addressId: string,
    ) => {
    return await $cpFetch<IAccountAddresses|null>(
        accountPaths.addressesSingle(userEmail, addressId), {
        method: 'DELETE',
    });
};

export const getSingleAddress = (id: string) => $cpFetch<ICpAddress>(accountPaths.addressesSingle(useCpUser().userEmail!, id));

export const verifyAddress = (id: string, code: string) => $cpFetch(accountPaths.addressValidate(useCpUser().userEmail!, id), {
    method: 'POST',
    body: {code},
});

export const getDeliveryAddressMD5 = async (userId: string) => {
    return await $cpFetch<{ deliveryAddressMD5: string }>(accountPaths.md5(userId));
};
